import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lastClickedMenu: '',
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setLastClickedMenu: (state, action) => {
      state.lastClickedMenu = action.payload;
    },
    resetSidebar: () => initialState, // Reset the state to its initial value
  },
});

export const { setLastClickedMenu, resetSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer;
